import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import Slider from "react-slick";

const ProductListOne = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  // Add to cart handler
  const handleAddToCart = (product) => {
    if (!user) {
      alert("Please login to add products to cart");
      navigate("/account");
      return;
    }

    const cart = localStorage.getItem("cart")
      ? JSON.parse(localStorage.getItem("cart"))
      : [];

    const existingProductIndex = cart.findIndex((p) => p.id === product._id);
    if (existingProductIndex !== -1) {
      cart[existingProductIndex].quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    localStorage.setItem("cart", JSON.stringify(cart));
    toast.success(`${product.name} added to cart!`);
    navigate("/cart");
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/product/list`
        );
        if (response.data.success) {
          setProducts(response.data.products);
        } else {
          console.error("Error fetching products:", response.data.message);
        }
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  // Custom arrows
  const SampleNextArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        onClick={onClick}
        style={{
          background: "white",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          right: "-20px",
          top: "40%",
          cursor: "pointer",
          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          zIndex: 2,
        }}
      >
        <i className="ph ph-caret-right" style={{ fontSize: "20px", color: "#333" }}></i>
      </div>
    );
  };

  const SamplePrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        onClick={onClick}
        style={{
          background: "white",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          left: "-20px",
          top: "40%",
          cursor: "pointer",
          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          zIndex: 2,
        }}
      >
        <i className="ph ph-caret-left" style={{ fontSize: "20px", color: "#333" }}></i>
      </div>
    );
  };

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 600,
    slidesToShow: 5,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <h4>Loading products...</h4>
      </div>
    );
  }

  return (
    <div style={{ padding: "50px 0", background: "#f8f9fa" }}>
      <div style={{ width: "100%", margin: "0 auto" }}>
        <div
          style={{
            background:
              "linear-gradient(to right, #56ab2f, #a8e063, #6bbf59, #9ce88f, #3a7d44)",
            padding: "40px 30px",
            borderRadius: "20px",
            boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
          }}
        >
          <div
            style={{
              marginBottom: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h2
              style={{
                margin: 0,
                fontSize: "24px",
                color: "#333",
                fontWeight: "700",
              }}
            >
              Shop by Products
            </h2>
          </div>

          {products.length > 0 ? (
            <Slider {...settings}>
              {products.map((product) => (
                <div key={product._id} style={{ padding: "10px" }}>
                  <div
                    style={{
                      background: "white",
                      borderRadius: "16px",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                      textAlign: "center",
                      padding: "20px 15px",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(1.05)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  >
                    {/* Product Image */}
                    <div
                      style={{
                        width: "160px",
                        height: "160px",
                        margin: "0 auto",
                        overflow: "hidden",
                        borderRadius: "12px",
                      }}
                    >
                      <Link to={`/products`}>
                        <img
                          src={
                            product.image?.[0] ||
                            "/assets/images/thumbs/placeholder.jpg"
                          }
                          alt={product.name}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            transition: "transform 0.3s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.15)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                        />
                      </Link>
                    </div>

                    {/* Product Info */}
                    <div style={{ marginTop: "15px" }}>
                      <p
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#333",
                          lineHeight: "1.3",
                          marginBottom: "6px",
                        }}
                      >
                        <Link
                          to={`/product-details/${product._id}`}
                          style={{ color: "#333", textDecoration: "none" }}
                        >
                          {product.name}
                        </Link>
                      </p>

                      <p
                        style={{
                          color: "#2b9348",
                          fontWeight: "700",
                          margin: "4px 0",
                        }}
                      >
                        ₹{product.offerPrice || product.price}
                        <span
                          style={{
                            color: "#777",
                            fontSize: "13px",
                            marginLeft: "5px",
                          }}
                        >
                          / {product.unit || "unit"}
                        </span>
                      </p>

                      {/* Seller and Stock Info */}
                      <div
                        style={{
                          background: "#f4f7f6",
                          borderRadius: "10px",
                          padding: "8px 10px",
                          marginTop: "8px",
                          fontSize: "13px",
                          textAlign: "left",
                        }}
                      >
                        <p style={{ margin: 0, color: "#333" }}>
                          👤 Seller:{" "}
                          <span style={{ fontWeight: "600" }}>
                            {product.seller?.name || "Unknown"}
                          </span>
                        </p>
                        <p style={{ margin: "3px 0", color: "#555" }}>
                          📦 Stock:{" "}
                          <span
                            style={{
                              color:
                                product.stock < 10
                                  ? "#d9534f"
                                  : "#2b9348",
                              fontWeight: "600",
                            }}
                          >
                            {product.stock || 0} left
                          </span>
                        </p>
                      </div>

                      <button
                        onClick={() => handleAddToCart(product)}
                        style={{
                          background:
                            "linear-gradient(90deg, #3bb77e, #2eb872)",
                          border: "none",
                          color: "white",
                          padding: "8px 20px",
                          borderRadius: "20px",
                          cursor: "pointer",
                          fontWeight: "600",
                          marginTop: "12px",
                        }}
                      >
                        Add to Cart
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          ) : (
            <div className="text-center">
              <h5>No products available</h5>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductListOne;
